import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { compose } from 'ramda';

import { withEditMode } from '_containers/BaseComponent';
import { ListOfFileDownloadsProps } from './definitions';
import { Container, ListWrapper } from './StyledListOfFileDownloads';
import HeadingWithDescription from '_utils/components/Corporate/HeadingWithDescription';

const DownloadableFiles: React.FC<ListOfFileDownloadsProps> = ({ rendering, editMode, fields }) => {
  const childRenderings = rendering?.placeholders?.['jss-downloadable-files'] || [];

  const heading = fields.data.datasource?.heading?.jss;
  const headingLevel = fields.data.datasource?.headingLevel?.jss;
  const description = fields.data.datasource?.description?.jss;

  if (editMode || childRenderings.length >= 1) {
    return (
      <Container>
        {Boolean(heading || description) && (
          <HeadingWithDescription
            headingField={heading}
            descriptionField={description}
            headingLevel={headingLevel}
          />
        )}
        <ListWrapper $editMode={editMode}>
          <Placeholder name="jss-downloadable-files" rendering={rendering} />
        </ListWrapper>
      </Container>
    );
  } else {
    return null;
  }
};

export default compose(withEditMode)(DownloadableFiles);
